// Compteur Taxi en direct (course en cours uniquement)
export default function TaxiLiveMeter({ taxiMeter }) {
  if (!taxiMeter) return null;
  return (
    <div
      className="bg-gradient-to-r from-[#0F172A] via-[#1E293B] to-[#0F172A] rounded-[2rem] p-5 border-2 border-[#D4AF37] shadow-2xl"
      data-testid="taxi-live-meter"
    >
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-2xl bg-[#D4AF37] flex items-center justify-center animate-pulse">
            <span className="text-2xl">🚕</span>
          </div>
          <div>
            <p className="text-[10px] font-black uppercase tracking-widest text-emerald-400">
              ● Course Taxi en cours
            </p>
            <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest mt-0.5">
              Compteur en direct
            </p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-[10px] font-black uppercase tracking-widest text-[#D4AF37]">
            Tarif actuel
          </p>
          <p className="text-3xl font-black italic text-white tracking-tighter">
            {Number(taxiMeter.current_fare).toLocaleString("fr-FR")}
            <span className="text-sm not-italic text-[#D4AF37] ml-1">FCFA</span>
          </p>
          <p className="text-[10px] text-slate-400 font-mono mt-0.5">
            {taxiMeter.distance_km?.toFixed(2)} km parcourus
          </p>
        </div>
      </div>
    </div>
  );
}
